import { Component, inject, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { ButtonComponent } from "../../shared/component/buttons/button.component";
import { MODELS_URLS } from "../../../util/common/url-parts";
import { ShowUIService } from "../../../core/service/show-ui.service";
import {
  UnsavedChangesModalService
} from "../../shared/component/unsaved-changes-modal-wrapper/service/unsaved-changes-modal.service";

@Component({
  selector: 'app-models-page',
  standalone: true,
  templateUrl: './models-page.component.html',
  styleUrl: './models-page.component.scss',
  imports: [
    RouterOutlet,
    ButtonComponent,
  ],
})
export class ModelsPageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  public router = inject(Router);
  private unsavedChangesService = inject(UnsavedChangesModalService);

  private activatedRoute = inject(ActivatedRoute);
  private showUIService = inject(ShowUIService);
  protected readonly MODELS_URLS = MODELS_URLS;

  selectedTab: string = MODELS_URLS.INVESTMENT;

  constructor() {
    this.showUIService.setShowSideNavBar(true);
  }

  ngOnInit(): void {
    this.initializeSelectedTab();

    // Track URL changes on navigation (including browser back button)
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.initializeSelectedTab();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async navigateTo(route: MODELS_URLS): Promise<void> {
    const canProceed = await this.unsavedChangesService.checkCanProceed();
    if (!canProceed) {
      return;
    }
    this.selectedTab = route;
    const url = MODELS_URLS.BASE + '/' + route;
    this.router.navigate([url], { queryParams: this.activatedRoute.snapshot.queryParams });
  }

  private initializeSelectedTab(): void {
    const currentUrl = this.router.url;

    if (currentUrl.includes(MODELS_URLS.FUND_BUDGET)) {
      this.selectedTab = MODELS_URLS.FUND_BUDGET;
    } else if (currentUrl.includes(MODELS_URLS.INVESTMENT)) {
      this.selectedTab = MODELS_URLS.INVESTMENT;
    } else {
      this.selectedTab = MODELS_URLS.INVESTMENT;
    }
  }
}
